module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('em', [_vm._v("Also by Donna Leon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Death at La Fenice"), _c('br'), _vm._v("Death in a Strange Country"), _c('br'), _vm._v("Dressed for Death"), _c('br'), _vm._v("Death and Judgment"), _c('br'), _vm._v("Quietly in Their Sleep"), _c('br'), _vm._v("A Noble Radiance"), _c('br'), _vm._v("Fatal Remedies"), _c('br'), _vm._v("Friends in High Places"), _c('br'), _vm._v("A Sea of Troubles"), _c('br'), _vm._v("Wilful Behaviour"), _c('br'), _vm._v("Uniform Justice"), _c('br'), _vm._v("Doctored Evidence"), _c('br'), _vm._v("Blood from a Stone"), _c('br'), _vm._v("Through a Glass, Darkly"), _c('br'), _vm._v("Suffer the Little Children"), _c('br'), _vm._v("The Girl of His Dreams"), _c('br'), _vm._v("About Face"), _c('br'), _vm._v("A Question of Belief"), _c('br'), _vm._v("Handel’s Beastiary")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24ca32ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm.vue
// module id = 60
// module chunks = 0